var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row",on:{"click":_vm.returnClick}},[_c('div',{staticClass:"col-md-2"},[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]),_c('div',{staticClass:"col-md-10"},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }